export default __webpack_public_path__ + "static/media/mastercard.85e3646e.svg";